import { DeviceEventEmitter } from "~/ui/primitives"

export const globalSpinner = {
  /**
   * @event globalSpinnerShow
   * Spinner组件显示方法 text 显示的文本
   * @param text
   */
  show(text = "") {
    DeviceEventEmitter.emit("globalSpinnerShow", text)
  },

  /**
   * @event globalSpinnerHide
   * Spinner组件关闭方法
   */
  close() {
    DeviceEventEmitter.emit("globalSpinnerHide")
  },
}
